import { BackAppBar } from "@/components/ui";
import { QUERY_KEYS } from "@/libraries/constant";
import { getMessageQueryOptions } from "@/queries";
import {
	CreateReminderSearchParamsSchema,
	ReminderFormFieldSchema,
} from "@/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { onlineManager, useQuery } from "@tanstack/react-query";
import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { FormProvider, useForm } from "react-hook-form";
import RemminderForm from "../-components/RemminderForm";

export const Route = createFileRoute("/dashboard/inbox/reminders/create")({
	validateSearch: zodSearchValidator(CreateReminderSearchParamsSchema),
	search: {
		middlewares: [retainSearchParams(["message"])],
	},
	loaderDeps: ({ search }) => ({
		messageId: search.message,
	}),
	loader: ({ context, deps }) => {
		if (!deps.messageId) return;
		if (onlineManager.isOnline() && !context.isRestoring) {
			return context.queryClient.ensureQueryData(
				getMessageQueryOptions(deps.messageId),
			);
		}
		return context.queryClient.getQueryData([
			QUERY_KEYS.GET_MESSAGE,
			deps.messageId,
		]);
	},
	component: RouteComponent,
});

function RouteComponent() {
	const messageId = Route.useLoaderDeps({
		select: (s) => s.messageId,
	});
	const messageQuery = useQuery(getMessageQueryOptions(messageId));
	const form = useForm<ReminderFormFieldSchema>({
		mode: "all",
		resolver: zodResolver(ReminderFormFieldSchema),
		defaultValues: async () => ({
			repeat: "Never",
			remind_me: false,
			name: messageQuery.data?.message?.text || "",
		}),
	});

	return (
		<>
			<BackAppBar
				className="!bg-gradient-contact [&_*_]:text-white"
				title="Add to Reminders"
			/>
			<FormProvider {...form}>
				<div className="container py-3 h-full">
					<RemminderForm />
				</div>
			</FormProvider>
		</>
	);
}
